import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { BarChart } from 'components/Charts';
import Card from 'components/Card';
import Heading from 'components/Heading';
import Box from 'components/Box';
import Flex from 'components/Flex';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function BarChartCard(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    chartProps = _objectWithoutProperties(_ref, _excluded);
  var titleIdValue = titleId || 'bar-chart-card-title';
  return /*#__PURE__*/_jsx(Card, {
    role: "region",
    "aria-labelledby": titleIdValue,
    children: /*#__PURE__*/_jsxs(Flex, {
      column: true,
      align: "stretch",
      height: "100%",
      gap: "xs",
      children: [title && /*#__PURE__*/_jsx(Box, {
        py: "s",
        px: "m",
        children: /*#__PURE__*/_jsx(Heading, {
          as: "h3",
          id: titleIdValue,
          children: title
        })
      }), /*#__PURE__*/_jsx(Box, {
        px: "s",
        mb: "s",
        mt: title ? 0 : 'm',
        minHeight: "200px",
        children: /*#__PURE__*/_jsx(BarChart, _objectSpread({}, chartProps))
      })]
    })
  });
}
export default BarChartCard;